module.exports = __webpack_public_path__ + "bd8f7b26fdd20496fda83936429ba90e.png";